/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */

export interface RegisterDeviceDto {
  /** Serial number of the inventory item to register as a new device */
  serialNumber: string;
  /** UUID of the location where the device will be installed */
  locationId: string;
  /** UUID of the space where the device will be installed */
  spaceId: string;
}
